import React from "react";
import { X, ArrowRightLeft } from "lucide-react";
import { Panel } from "@/components/common/Panel";
import { TID } from "@/lib/testIds";

/** Per-role outcome of the bulk "Migrate All to Fiori" pass. */
export function MigrateAllResultsPanel({ result, dismiss }) {
    if (!result) return null;
    return (
        <Panel
            eyebrow="Bulk Fiori Migration"
            title={<span className="inline-flex items-center gap-1.5"><ArrowRightLeft size={14} className="text-cyan-400" /> Migrate All — outcome</span>}
            action={
                <button data-testid={TID.migrateAllDismissBtn} onClick={dismiss} className="text-slate-500 hover:text-cyan-300 transition-colors" title="Dismiss">
                    <X size={14} />
                </button>
            }
        >
            <div data-testid={TID.migrateAllResultPanel} className="space-y-2">
                <div className="flex flex-wrap items-center gap-3 text-[11px] font-mono">
                    <span className="text-slate-400">{result.candidates} T-code-only role(s) processed</span>
                    <span className="text-emerald-300">{result.migrated} migrated onto catalogs</span>
                    {result.unmatched > 0 && <span className="text-amber-300">{result.unmatched} with no catalog match</span>}
                    <span className="text-cyan-300">{result.avg_coverage_pct}% avg T-code coverage</span>
                </div>
                {result.results.map((r) => (
                    <div key={r.role_id} data-testid={TID.migrateAllRow(r.role_id)} className={`panel-elevated p-3 border-l-2 ${r.catalogs_matched > 0 ? "border-cyan-500/50" : "border-amber-500/40"}`}>
                        <div className="flex items-center gap-2 flex-wrap text-[11px] font-mono">
                            <span className="text-white text-xs">{r.role_name}</span>
                            <span className={r.coverage_pct >= 60 ? "text-emerald-300" : r.coverage_pct > 0 ? "text-amber-300" : "text-rose-300"}>
                                {r.coverage_pct}% covered
                            </span>
                            <span className="text-slate-500">{r.catalogs_matched} catalog(s) · {r.app_count} app(s) · {r.tcode_count} T-code(s)</span>
                        </div>
                        {r.uncovered_tcodes.length > 0 && (
                            <div className="text-[10px] font-mono text-slate-500 mt-1">
                                <span className="text-amber-400/80">unmatched:</span> {r.uncovered_tcodes.join(", ")}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </Panel>
    );
}
